/**
 * English strings for the staff-only Companies admin page (`/app/companies`).
 * Kept out of the main translation file to stay within the size gate (PREC-4063).
 */
export const enCompanies = {
	title: "Other Organizations",
	subtitle: "Here you can find other organizations",
	search: "Search for company or user",
	name: "Name",
	linkedinUrl: "LinkedIn URL",
	users: "Users",
	/** Shown under the seat count when the search term matched people rather than a company name. */
	matchedUsers: {
		more: "+{{count}} more",
	},
	autoInvite: "Auto Invite",
	create: {
		button: "Create New Company",
		title: "Create New Company",
	},
	delete: {
		title: "Delete Company",
	},
	update: {
		title: "Update Company",
	},
	lifecycle: {
		stateColumn: "Lifecycle",
		datesColumn: "Lifecycle dates",
		state: {
			ACTIVE: "Active",
			GRACE: "Read-only",
			ARCHIVED: "Archived",
			DUE_FOR_DELETION: "Due for deletion",
		},
		readOnlyUntil: "read-only until {{date}}",
		archivedAt: "archived {{date}}",
		deletionAt: "deletion {{date}}",
		deletionOverdue: "deletion overdue since {{date}}",
	},
	licences: {
		column: "Licences",
		manage: "Manage licences",
		title: "Licences for {{name}}",
		linkedin: "LinkedIn sender seats",
		email: "Email sender accounts",
		used: "{{used}} of {{total}} in use",
		bonusBadge: "+{{amount}} bonus",
		breakdown: "{{included}} included in plan · {{paid}} paid via Stripe · {{bonus}} bonus",
		bonusSeats: "Bonus seats",
		inUseWarning:
			"{{used}} seats are in use. Lowering the bonus below that will block new sender assignments until seats are freed.",
		invalid: "Enter a whole number between 0 and {{max}}.",
		saved: "Bonus seats updated.",
		loading: "Loading seats…",
	},
};
